import React from 'react';
interface TextareaProps {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  error?: string;
  required?: boolean;
  className?: string;
  name?: string;
}
export function Textarea({
  placeholder,
  value,
  onChange,
  rows = 4,
  error,
  required = false,
  className = '',
  name
}: TextareaProps) {
  return <div className="w-full" data-id="element-377">
      <textarea name={name} placeholder={placeholder} value={value} onChange={onChange} required={required} rows={rows} className={`w-full rounded-md border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#E63946] focus:border-transparent transition-all resize-none ${error ? 'border-red-500' : ''} ${className}`} data-id="element-378" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-379">{error}</p>}
    </div>;
}